
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/moveyouout",
      function () {
        return require("private-next-pages/moveyouout/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/moveyouout"])
      });
    }
  